// Update contents object below

const contents = {
  header: 'Intel Corporation',
  video:
    'https://player.vimeo.com/video/913061557?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
  videoTitle: 'Intel - Argonne',
  title: 'Accelerating Science at Scale with Intel AI',
  copy: 'Whether researching new cancer treatments, climate change, or the far reaches of the cosmos—speed is everything. That’s why Intel, Hewlett Packard Enterprise, and Argonne National Laboratory have teamed up to build Aurora, one of the fastest supercomputers on the planet. See how Intel’s groundbreaking hardware and AI solutions are unlocking new possibilities for researchers everywhere with one of the world’s fastest supercomputers, Aurora, at Argonne National Laboratory, co-built with Hewlett Packard Enterprise (HPE).',
  url: 'https://sponsorcontent.cnn.com/interactive/intel/it-starts-with-intel/',
  button: 'More Intel Stories'
};

export default contents;
